import type { Dispatch as ToolkitDispatch } from '@reduxjs/toolkit';
import type { UIPaymentGroups, UIPayoutGroups } from 'store/formatters';
import type { PayHubCashierContractsCashierSettingsResponse } from 'store/models';
import { disableTabs, setActiveTab, setTabs } from 'store/slices//tabs';
import type { CurrencyBase } from 'store/slices/wallet';
import { setWalletData } from 'store/slices/wallet';
import { getWalletInitData } from 'utils/wallet';

import type { CurrencyChangeReason } from '../../providers/AppCoreProvider/AppCoreProvider';
import { CURRENCY_CHANGE_REASON } from '../../providers/AppCoreProvider/AppCoreProvider';

export interface InitialDataProps {
  cashierSettings: PayHubCashierContractsCashierSettingsResponse;
  userBalance?: number;
  walletCurrencies: CurrencyBase[];
  groups: UIPayoutGroups[] | UIPaymentGroups[];
  setCurrencyChangeReason: (reason: CurrencyChangeReason) => void;
  selectedCurrency: CurrencyBase | null;
  defaultFiatCurrency: string | null;
  isDepositFlow: boolean;
}

export const setWalletDataAndTabs = (payload: InitialDataProps) => (dispatch: ToolkitDispatch) => {
  const {
    cashierSettings,
    userBalance,
    defaultFiatCurrency,
    walletCurrencies,
    groups,
    selectedCurrency,
    setCurrencyChangeReason,
    isDepositFlow,
  } = payload;
  const { tabs, activeTab, cryptoCurrencies, onRampCurrencies, fiatCurrencies } = getWalletInitData(
    walletCurrencies,
    selectedCurrency,
    isDepositFlow,
  );
  dispatch(
    setWalletData({
      cashierSettings,
      userBalance,
      walletCurrencies,
      cryptoCurrencies,
      onRampCurrencies,
      fiatCurrencies,
      groups,
      selectedCurrency,
      defaultFiatCurrency,
    }),
  );

  if (!cashierSettings.multi_currency_cashier || walletCurrencies.length === 0) {
    dispatch(disableTabs());
    return;
  }

  if (cashierSettings.multi_currency_cashier) {
    setCurrencyChangeReason(CURRENCY_CHANGE_REASON.INITIAL_INIT);
  }

  if (tabs?.length > 0) {
    const currentTab = activeTab || tabs[0];
    dispatch(setTabs(tabs));
    dispatch(setActiveTab(currentTab));
  }
};
